export default __webpack_public_path__ + "static/media/lu.3d30b2a2.svg";